export default __webpack_public_path__ + "static/media/credit.138bae72.svg";